// extracted by mini-css-extract-plugin
export default {"carousel_container":"styles_carousel_container__v5Qx2","carousel_slide":"styles_carousel_slide__I0yHq","carousel_counter":"styles_carousel_counter__OuIVn"};